export const IconMail = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='24.000000' height='24.000000' viewBox='0 0 24 24' fill='none'>
            <defs />
            <path
                d='M16.43 3.92C17.63 3.92 18.79 4.39 19.64 5.25C20.49 6.1 20.97 7.25 20.97 8.45L20.97 15.54C20.97 18.04 18.93 20.07 16.43 20.07L7.56 20.07C5.06 20.07 3.02 18.04 3.02 15.54L3.02 8.45C3.02 5.95 5.05 3.92 7.56 3.92L16.43 3.92ZM17.93 9.72L13.81 13.03C13.31 13.42 12.69 13.64 12.05 13.64C11.41 13.64 10.8 13.42 10.3 13.03L6.22 9.84L6.1 9.72C5.89 9.46 5.92 9.07 6.16 8.83C6.39 8.58 6.78 8.56 7.06 8.76L11.1 12C11.63 12.43 12.37 12.43 12.89 12L16.94 8.76C17.08 8.64 17.25 8.58 17.44 8.58C17.62 8.6 17.79 8.68 17.92 8.82C18.14 9.08 18.14 9.46 17.93 9.72Z'
                fill='currentcolor'
                fill-opacity='1.000000'
                fill-rule='evenodd'
            />
        </svg>
    );
};
